import { Routes } from '@angular/router';

export const multiPlanChildRoutes: Routes = [
  {
    path: '',
    redirectTo: 'protection-details',
    pathMatch: 'full',
  },
  {
    path: 'protection-details',
    loadComponent: () =>
      import('@features/multi-plan').then((module) => module.PlanSaleComponent),
  },
  {
    path: 'appliance-details',
    loadComponent: () =>
      import('@features/multi-plan').then(
        (module) => module.ApplianceDetailsComponent,
      ),
  },
  {
    path: 'review-cover',
    loadComponent: () =>
      import('@features/multi-plan').then(
        (module) => module.ReviewCoverComponent,
      ),
  },
];

export const errorRoutes: Routes = [
  {
    path: 'error',
    loadComponent: () =>
      import('@features/error').then((module) => module.ErrorComponent),
  },
];

export const supportRoutes: Routes = [
  {
    path: 'support',
    loadComponent: () =>
      import('@features/support').then(
        (module) => module.SupportNavigationComponent,
      ),
    children: [
      {
        path: 'accessibility-policy',
        loadComponent: () =>
          import('@features/support').then(
            (module) => module.AccessibilityPolicyComponent,
          ),
      },
      {
        path: 'contact-us',
        loadComponent: () =>
          import('@features/support').then(
            (module) => module.ContactUsComponent,
          ),
      },
      {
        path: 'cookies-policy',
        loadComponent: () =>
          import('@features/support').then(
            (module) => module.CookiesPolicyComponent,
          ),
      },
      {
        path: 'privacy-policy',
        loadComponent: () =>
          import('@features/support').then(
            (module) => module.PrivacyPolicyComponent,
          ),
      },
    ],
  },
];
